import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
  connect() {
    this.loadChannelPositions()
    this.makeSortable()
  }

  loadChannelPositions() {
    const positions = this.getChannelPositions()

    // Appliquer les positions personnalisées
    const container = this.element
    const programs = Array.from(container.children)

    // Trier selon les positions personnalisées
    programs.sort((a, b) => {
      const channelA = a.querySelector('[id^="program-"]')?.id.replace('program-', '')
      const channelB = b.querySelector('[id^="program-"]')?.id.replace('program-', '')

      const posA = positions[channelA] || 999
      const posB = positions[channelB] || 999

      return posA - posB
    })

    // Réorganiser le DOM
    programs.forEach(program => {
      container.appendChild(program)
    })
  }

  makeSortable() {
    new Sortable(this.element, {
      animation: 150,
      ghostClass: 'opacity-50',
      chosenClass: 'bg-violet-100 dark:bg-violet-900',
      dragClass: 'shadow-lg',
      handle: '.drag-handle',

      onEnd: (evt) => {
        this.saveNewPositions()
      }
    })
  }

  saveNewPositions() {
    const positions = {}

    this.element.querySelectorAll('[id^="program-"]').forEach((element, index) => {
      const channelId = element.id.replace('program-', '')
      positions[channelId] = index + 1
    })

    localStorage.setItem('tv_channel_positions', JSON.stringify(positions))

    // Déclencher un événement pour le filtre si nécessaire
    document.dispatchEvent(new CustomEvent('channelPositionsUpdated'))
  }

  getChannelPositions() {
    try {
      const stored = localStorage.getItem('tv_channel_positions')
      return stored ? JSON.parse(stored) : {}
    } catch (e) {
            return {}
    }
  }
}